import { ADD_USER } from '../actionTypes'

export const addUser = (data: object) => ({
  type: ADD_USER.name,
  api: {
    url: 'guests/add_user',
    data,
  },
})
